module.exports = __webpack_public_path__ + "img/location.bb2736fd.png";